import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import DesignvendorEditForm from './DesignvendorEditForm';
import DesignvendorList from './DesignvendorList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import DesignvendorListView from './DesignvendorListView'


export default function DesignvendorDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.designvendorDashboard);
  const [ designvendorId, setDesignvendorId] = React.useState('');
  const [reloadDesignvendorList, setReloadDesignvendorList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <DesignvendorEditForm 
            setReloadDesignvendorList={setReloadDesignvendorList}
            designvendorId={designvendorId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <DesignvendorListView 
                      setDesignvendorId = {setDesignvendorId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
